"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelSubscriptionURL = exports.socialLinkedinURL = exports.socialInstagramURL = exports.socialYoutubeURL = exports.socialFacebookURL = exports.socialTwitterURL = exports.mobileURL = exports.legalURL = exports.giftURL = exports.faqURL = exports.socialTechURL = exports.socialBlogURL = exports.pressURL = exports.jobsURL = exports.b2bShopURL = exports.socialMagazineURL = exports.learningWithBabbelURL = void 0;
const removeNamespace_1 = __importDefault(require("./removeNamespace"));
const linkOption_1 = require("../../types/linkOption");
const locale_1 = require("../../types/locale");
const subdomainWithoutMyJs = (locale = locale_1.Locale.EN_GB) => {
    switch (locale) {
        case locale_1.Locale.EN:
            return 'www';
        case locale_1.Locale.EN_GB:
            return 'uk';
        case locale_1.Locale.SV:
            return 'se';
        case locale_1.Locale.UK:
            return 'ua';
        default:
            return locale;
    }
};
const learningWithBabbelURL = (dataConfig) => {
    const { locale, staticBaseUrlTemplate } = dataConfig;
    const learningWithBabbelBaseUrl = staticBaseUrlTemplate.replace('%{subdomain}', 'about').replace('.cn', '.com');
    if (locale === locale_1.Locale.UK) {
        return `${learningWithBabbelBaseUrl}/en`;
    }
    return `${learningWithBabbelBaseUrl}/${locale}`;
};
exports.learningWithBabbelURL = learningWithBabbelURL;
const socialMagazineURL = (dataConfig) => {
    const { locale, staticBaseUrlTemplate } = dataConfig;
    if (locale === locale_1.Locale.UK || locale === locale_1.Locale.EN_GB) {
        const wwwBaseUrl = `${staticBaseUrlTemplate.replace('%{subdomain}', 'www')}`;
        return `${wwwBaseUrl}/en/magazine`;
    }
    const subdomain = subdomainWithoutMyJs(locale);
    return `${staticBaseUrlTemplate}/${locale}/magazine`.replace('%{subdomain}', subdomain);
};
exports.socialMagazineURL = socialMagazineURL;
const b2bShopURL = (dataConfig) => {
    const { locale } = dataConfig;
    const babbelForBusinessBaseUrl = `babbelforbusiness.com`;
    switch (locale) {
        case locale_1.Locale.DE:
            return 'https://www.babbelfuerunternehmen.de';
        case locale_1.Locale.EN:
            return `https://us.${babbelForBusinessBaseUrl}`;
        case locale_1.Locale.FR:
        case locale_1.Locale.IT:
            return `https://${locale}.${babbelForBusinessBaseUrl}`;
        default:
            return `https://www.${babbelForBusinessBaseUrl}`;
    }
};
exports.b2bShopURL = b2bShopURL;
const jobsURL = (dataConfig) => {
    const { staticBaseUrlTemplate } = dataConfig;
    return staticBaseUrlTemplate.replace('%{subdomain}', 'jobs').replace('.cn', '.com');
};
exports.jobsURL = jobsURL;
const pressURL = (dataConfig) => {
    const { locale, staticBaseUrlTemplate } = dataConfig;
    const subdomain = subdomainWithoutMyJs(locale);
    const wwwBaseUrl = `${staticBaseUrlTemplate.replace('%{subdomain}', 'www')}`;
    const pressNamespace = {
        [locale_1.Locale.EN]: 'press',
        [locale_1.Locale.DE]: 'presse',
        [locale_1.Locale.ES]: 'prensa',
        [locale_1.Locale.FR]: 'presse',
        [locale_1.Locale.IT]: 'press',
        [locale_1.Locale.PT]: 'imprensa'
    };
    switch (locale) {
        case locale_1.Locale.EN:
        case locale_1.Locale.UK:
            return `${wwwBaseUrl}/${pressNamespace.en}/en-us`;
        case locale_1.Locale.DE:
        case locale_1.Locale.FR:
        case locale_1.Locale.IT:
        case locale_1.Locale.ES:
            return `${staticBaseUrlTemplate.replace('%{subdomain}', subdomain)}/${pressNamespace[locale]}/${locale}-${locale}`;
        case locale_1.Locale.PT:
            return `${staticBaseUrlTemplate.replace('%{subdomain}', subdomain)}/${pressNamespace[locale]}/pt-br`;
        default:
            return `${staticBaseUrlTemplate.replace('%{subdomain}', 'uk')}/press/en-gb`;
    }
};
exports.pressURL = pressURL;
const socialBlogURL = (dataConfig) => {
    const { locale, staticBaseUrlTemplate } = dataConfig;
    const subdomain = subdomainWithoutMyJs(locale);
    const blogNamespace = {
        [locale_1.Locale.DE]: 'inside-babbel',
        [locale_1.Locale.ES]: 'babbel-desde-dentro',
        [locale_1.Locale.FR]: 'le-monde-de-babbel',
        [locale_1.Locale.IT]: 'babbel-si-racconta',
        [locale_1.Locale.PT]: 'historias-da-babbel',
        [locale_1.Locale.SV]: 'inside-babbel'
    };
    switch (locale) {
        case locale_1.Locale.DE:
        case locale_1.Locale.ES:
        case locale_1.Locale.FR:
        case locale_1.Locale.IT:
        case locale_1.Locale.PT:
        case locale_1.Locale.SV:
            return `${staticBaseUrlTemplate.replace('%{subdomain}', subdomain)}/${locale}/magazine/category/${blogNamespace[locale]}`;
        default:
            return `${staticBaseUrlTemplate.replace('%{subdomain}', 'www')}/en/magazine/category/inside-babbel`;
    }
};
exports.socialBlogURL = socialBlogURL;
const socialTechURL = (dataConfig) => {
    const { staticBaseUrlTemplate } = dataConfig;
    const wwwBaseUrl = `${staticBaseUrlTemplate.replace('%{subdomain}', 'www')}`;
    return `${wwwBaseUrl}/en/magazine/category/babbel-bytes`;
};
exports.socialTechURL = socialTechURL;
const faqURL = (dataConfig) => {
    const { locale, staticBaseUrlTemplate } = dataConfig;
    const supportBaseUrl = `${staticBaseUrlTemplate.replace('%{subdomain}', 'support')}/hc`;
    switch (locale) {
        case locale_1.Locale.EN:
            return `${supportBaseUrl}/en-us`;
        case locale_1.Locale.EN_GB:
            return `${supportBaseUrl}/en-gb`;
        case locale_1.Locale.PT:
            return `${supportBaseUrl}/pt-br`;
        default:
            return `${supportBaseUrl}/${locale}`;
    }
};
exports.faqURL = faqURL;
const giftURL = (dataConfig) => {
    const { locale } = dataConfig;
    const subdomain = subdomainWithoutMyJs(locale);
    const giftBaseUrlTemplate = `https://%{subdomain}.babbel-giftshop.com/?utm_source=babbel_website&utm_medium=referrer&utm_campaign=footer`;
    switch (locale) {
        case locale_1.Locale.EN:
        case locale_1.Locale.UK:
            return `${giftBaseUrlTemplate.replace('%{subdomain}', 'us')}`;
        default:
            return `${giftBaseUrlTemplate.replace('%{subdomain}', subdomain)}`;
    }
};
exports.giftURL = giftURL;
const legalURL = (dataConfig, linkName) => {
    const { locale, staticBaseUrlTemplate } = dataConfig;
    const legalName = (linkName === linkOption_1.SecondaryLinkName.Copyright ? linkOption_1.SecondaryLinkName.Imprint : linkName);
    const legalBaseURL = staticBaseUrlTemplate.replace('%{subdomain}', 'about').replace('.cn', '.com');
    return `${legalBaseURL}/${locale}/${(0, removeNamespace_1.default)(legalName)}`;
};
exports.legalURL = legalURL;
const mobileURL = (dataConfig) => {
    const { locale, staticBaseUrlTemplate } = dataConfig;
    const subdomain = subdomainWithoutMyJs(locale);
    return `${staticBaseUrlTemplate}/mobile`.replace('%{subdomain}', subdomain);
};
exports.mobileURL = mobileURL;
const socialTwitterURL = () => 'https://twitter.com/babbel';
exports.socialTwitterURL = socialTwitterURL;
const socialFacebookURL = (dataConfig) => {
    const { locale } = dataConfig;
    const baseURL = 'https://www.facebook.com/babbel';
    switch (locale) {
        case locale_1.Locale.DE:
            return `${baseURL}.deu`;
        case locale_1.Locale.FR:
            return `${baseURL}.fra`;
        case locale_1.Locale.IT:
            return `${baseURL}.ita`;
        case locale_1.Locale.PL:
            return `${baseURL}.polska`;
        case locale_1.Locale.PT:
            return `${baseURL}.por`;
        default:
            return `${baseURL}.languages`;
    }
};
exports.socialFacebookURL = socialFacebookURL;
const socialYoutubeURL = (dataConfig) => {
    const { locale } = dataConfig;
    const baseURL = 'https://www.youtube.com';
    switch (locale) {
        case locale_1.Locale.DE:
            return `${baseURL}/babbelsprachenlernen`;
        case locale_1.Locale.ES:
            return `${baseURL}/babbelaprendeidiomas`;
        case locale_1.Locale.FR:
            return `${baseURL}/babbelfrance`;
        case locale_1.Locale.IT:
            return `${baseURL}/BabbelItalia`;
        case locale_1.Locale.PL:
            return `${baseURL}/channel/UCtxKNuKkuT5QKP_11-MiL4A`;
        case locale_1.Locale.PT:
            return `${baseURL}/babbelaprendaidiomas`;
        default:
            return `${baseURL}/lessonnine`;
    }
};
exports.socialYoutubeURL = socialYoutubeURL;
const socialInstagramURL = () => 'https://www.instagram.com/babbel/';
exports.socialInstagramURL = socialInstagramURL;
const socialLinkedinURL = () => 'https://www.linkedin.com/company/babbel-com';
exports.socialLinkedinURL = socialLinkedinURL;
const cancelSubscriptionURL = (dataConfig) => {
    const { locale, staticBaseUrlTemplate } = dataConfig;
    const topLevelDomain = staticBaseUrlTemplate.split('.')[staticBaseUrlTemplate.split('.').length - 1];
    const myBaseUrl = `https://my.babbel.${topLevelDomain}/${locale}`;
    const loginUrl = `${myBaseUrl}/authentication/login/email?cancel=true`;
    const returnToUrl = encodeURIComponent(`${myBaseUrl}/user-profile/account-information`);
    return `${loginUrl}&return_to=${returnToUrl}`;
};
exports.cancelSubscriptionURL = cancelSubscriptionURL;
//# sourceMappingURL=urls.js.map